import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "34",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m26.813 2.143.035 6.801h6.167l-.277.972h-.015c-.057.002-.199.008-3.027.008h-2.883v9.816l-.033 4.964v.118c.002 1.27.026 3.55.105 4.127.047.38.16.75.334 1.094.538 1.022 2.394 2.16 4.301 2.054 1.57-.087 2.242-.438 2.96-.855l.238.39a10.3 10.3 0 0 1-2.218 1.154 8.11 8.11 0 0 1-3.087.709c-1.943.04-3.261-.392-4.515-2.71-.549-1.022-.604-2.715-.601-4.872V19.01c.113-6.015.145-9.089.145-9.089l-4.004.006v-.356c1.8-.411 3.359-1.48 4.339-2.977 1.686-2.552 1.603-4.452 1.603-4.452h.433ZM7.904.093v.513C3.547 2.005.707 7.738 7.512 11.937l8.324 5.223c6.609 4.156 6.903 9.372 4.895 12.59 0 0-1.616 3.076-7.343 3.73v-.514c6.51-1.305 6.609-8.673 1.518-12.076l-8.421-5.222C3.008 13.332-2.427 9.325 1.197 3.59c0 0 1.86-2.844 6.707-3.497Zm27.58 32.403c.285 0 .516.22.516.492a.505.505 0 0 1-.517.492.505.505 0 0 1-.516-.492c0-.272.231-.492.516-.492ZM1 22.149c.293 6.387 2.007 10.118 8.176 10.817v.51C3.35 33.058.51 31.098.51 31.098v-8.95h.491ZM12.111 0c5.24.42 8.324 2.098 8.324 2.098l.003 7.83h-.588c-.244-5.125-1.371-8.81-7.74-9.416V0Z"
    }, null, -1)
  ])))
}
export default { render: render }